// ─────────────────────────────────────────────
//  Firebase Configuration — StockIQ Portal
//  Replace all values below with your own
//  Firebase project credentials.
//  Get them from: Firebase Console → Project Settings → Your apps
// ─────────────────────────────────────────────
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Firebase Cloud Messaging (for browser push alerts)
// Only initialise in browser environments
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {
  console.warn("FCM not available in this environment:", e.message);
}
export { messaging };
